// Calls back once, on the user's next wheel, swipe, tap or key anywhere in the window, and returns the function that
// stops listening. A phone card list or a board lane whose next page failed to load waits for this before asking
// again: asking at once looped for as long as the server failed, and a scroll event is not a sign of the user -
// the list's own spinner leaving shortens it and the browser scrolls it to fit (measured: ~40 requests in 2s).
// Captured, so it hears the gesture whichever element scrolls.
const GESTURES = ['wheel', 'touchmove', 'pointerdown', 'keydown'];

export const onNextUserGesture = (callback: () => void, target: Pick<Window, 'addEventListener' | 'removeEventListener'> = window) => {
  let called = false;
  const listener = () => {
    if (called) return;
    called = true;
    stop();
    callback();
  };
  const stop = () => GESTURES.forEach(gesture => target.removeEventListener(gesture, listener, { capture: true }));
  GESTURES.forEach(gesture => target.addEventListener(gesture, listener, { capture: true, passive: true }));
  return stop;
};
